import { useParams, Navigate } from "react-router-dom";
import { SECTIONS } from "@/lib/bachConfig";
import BachManager from "@/components/BachManager";

export default function BachSection() {
  const { section } = useParams();
  const config = SECTIONS[section];
  if (!config) return <Navigate to="/bach" replace />;
  return <BachManager key={section} config={config} />;
}
